/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @description
 *
 * @created at Thu Nov 30 2023
 **/

import { useContext } from "react";
import { ToastActionContext } from "./ToastContainer";

export default function useToast() {
	const handlers = useContext(ToastActionContext);
	if (!handlers) throw new Error("not found ToastActionContext");
	return { show: handlers.handleShow, hide: handlers.handleHide };
}
